const getExplorerLink = (blockchain: string, address: string): string => {
	const explorers: Record<string, string> = {
		TON: 'https://tonviewer.com', // TON viewer
		BSC: 'https://bscscan.com/address', // Binance Smart Chain
		ETH: 'https://etherscan.io/address', // Ethereum
		ETHEREUM: 'https://etherscan.io/address', // Ethereum
		POLYGON: 'https://polygonscan.com/address', // Polygon
		ARB: 'https://arbiscan.io/address', // Arbitrum
		ARBITRUM: 'https://arbiscan.io/address', // Arbitrum
		BASE: 'https://basescan.org/address', // Base
		ASSET: 'https://explorer.assetchain.org/address', // Hypothetical AssetChain explorer
		ASSETCHAIN: 'https://explorer.assetchain.org/address', // Hypothetical AssetChain explorer
	};

	const baseUrl = explorers[blockchain.toUpperCase()];
	if (!baseUrl) {
		console.warn(`Unknown blockchain: ${blockchain}`);
		return '#';
	}

	return `${baseUrl}/${address}`;
};

export default getExplorerLink;
